import { useMemo } from 'react';
import { useCheckoutEducatorLink } from '../useCheckoutEducatorLink';
import { useCheckoutContext } from '../CheckoutContext';

export const useCheckoutCourseLink = () => {
    const checkoutContext = useCheckoutContext();
    const educatorLink = useCheckoutEducatorLink();

    return useMemo(() => {
        return `${educatorLink}/${checkoutContext.course.slug}`;
    }, [educatorLink, checkoutContext]);
};
